import React from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import TreatmentDetailHero from '../sections/TreatmentDetailHero/TreatmentDetailHero';
import TreatmentDetailContent from '../sections/TreatmentDetailContent/TreatmentDetailContent';
import MetaHelmet from '../components/SEO/MetaHelmet';

const TreatmentDetail = () => {
    const { slug } = useParams();

    return (
        <>
            <MetaHelmet 
                title={`${slug} | Tedavilerimiz | Mona Klinik`}
                description="Mona Klinik'te sunulan diş tedavisi hakkında detaylı bilgi alın."
            />
            <Navbar />
            <TreatmentDetailHero slug={slug} />
            <TreatmentDetailContent slug={slug} />
            <Footer />
        </>
    );
};

export default TreatmentDetail; 